"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var DaytimeNap_1 = __importDefault(require("./DaytimeNap"));
var utils_1 = require("../utils");
var icons_1 = require("../../../../common/icons");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        root: {
            backgroundColor: theme.palette.background.default,
        },
        box: (_a = {
                backgroundColor: theme.palette.background.default,
                marginBottom: theme.spacing(4),
                boxShadow: theme.shadows[2],
                borderRadius: theme.youwell.shapes.borderRadius
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _a),
        entry: {
            '&+&': {
                marginTop: theme.spacing(6),
            },
        },
        entryTitle: {},
        dayTimeNapWrapper: (_b = {},
            _b[theme.breakpoints.down('xs')] = {
                display: 'flex',
                flexDirection: 'column',
            },
            _b),
        yesNoRadioBtns: {
            border: theme.youwell.borders.secondary,
            margin: theme.spacing(2, 2, 2, 0),
            padding: theme.spacing(1, 16, 1, 1),
        },
        input: {
            backgroundColor: theme.palette.common.white,
        },
        alwaysPresentContent: {
            padding: theme.spacing(4),
            borderRadius: theme.youwell.shapes.borderRadius,
        },
        toggleableContent: (_c = {
                backgroundColor: "".concat(theme.palette.secondary.main, "20"),
                padding: theme.spacing(5),
                margin: '0 auto'
            },
            _c[theme.breakpoints.down('xs')] = {
                maxWidth: '100%',
                padding: theme.spacing(2, 1),
            },
            _c),
        radioGroup: {
            display: 'flex',
            flexDirection: 'row',
            padding: theme.spacing(1, 0, 3, 0),
        },
        addDayTimeNapsBtnSection: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(2),
        },
        notValidTimeInputOrder: {
            color: theme.palette.error.main,
            marginTop: theme.spacing(1),
        },
    });
};
var useStyles = (0, core_1.makeStyles)(function (theme) { return styles(theme); }, { name: 'LogNaps' });
var LogNaps = function (_a) {
    var _b, _c, _d;
    var values = _a.values, date = _a.date, disabled = _a.disabled, handleValueChange = _a.handleValueChange;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var addDaytimeNap = function () {
        var updated = __spreadArray(__spreadArray([], values.daytimeNaps || [], true), [{
                wakeTime: undefined,
                sleepTime: undefined,
            }], false);
        handleValueChange('daytimeNaps')(updated);
    };
    var removeDaytimeNap = function (indexToRemove) { return function () {
        var _a;
        var updated = (_a = values.daytimeNaps) === null || _a === void 0 ? void 0 : _a.filter(function (d, i) { return i !== indexToRemove; });
        handleValueChange('daytimeNaps')(updated);
    }; };
    var handleWakeupValueChange = function (wakeUpIndex) { return function (updatedValue) {
        var updated = values.daytimeNaps && values.daytimeNaps.map(function (d, i) { return (i === wakeUpIndex ? updatedValue : d); });
        handleValueChange('daytimeNaps')(updated);
    }; };
    var handleDayTimeNapChange = function (event) {
        var hasDaytimeNaps = event.target.value === 'true';
        var updated = __assign(__assign({}, values.sleepProperties), { hasDaytimeNaps: hasDaytimeNaps });
        handleValueChange('sleepProperties')(updated);
        if (hasDaytimeNaps) {
            addDaytimeNap();
        }
        else {
            handleValueChange('daytimeNaps')([]);
        }
    };
    var unValidDaytimeNaps = (0, utils_1.dayTimeNapsUnValidItems)(date, values.daytimeNaps);
    var hasDaytimeNaps = !!((_b = values.sleepProperties) === null || _b === void 0 ? void 0 : _b.hasDaytimeNaps);
    var hasNoDaytimeNaps = ((_c = values.sleepProperties) === null || _c === void 0 ? void 0 : _c.hasDaytimeNaps) !== undefined && !values.sleepProperties.hasDaytimeNaps;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.alwaysPresentContent },
            React.createElement("div", { className: classes.entry },
                React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.dayTimeNaps')),
                React.createElement(core_1.RadioGroup, { className: classes.radioGroup, onChange: handleDayTimeNapChange },
                    React.createElement(core_1.FormControlLabel, { disabled: disabled, className: (0, classnames_1.default)(classes.yesNoRadioBtns, classes.input), value: "false", control: React.createElement(core_1.Radio, { checked: hasNoDaytimeNaps }), label: translate('sleepDiary.no') }),
                    React.createElement(core_1.FormControlLabel, { disabled: disabled, className: (0, classnames_1.default)(classes.yesNoRadioBtns, classes.input), value: "true", control: React.createElement(core_1.Radio, { checked: hasDaytimeNaps }), label: translate('sleepDiary.yes') })))),
        hasDaytimeNaps && (React.createElement("div", { className: classes.toggleableContent },
            React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.entryTitle }, translate('sleepDiary.dayTimeNapsDescription')),
            unValidDaytimeNaps.length > 0 && (React.createElement(core_1.Typography, { className: classes.notValidTimeInputOrder }, translate('sleepDiary.inCorrectSleepDataInputOrder'))),
            React.createElement("div", { className: classes.dayTimeNapWrapper }, (_d = values.daytimeNaps) === null || _d === void 0 ? void 0 :
                _d.map(function (item, i) { return (React.createElement(DaytimeNap_1.default
                // eslint-disable-next-line react/no-array-index-key
                , { 
                    // eslint-disable-next-line react/no-array-index-key
                    key: i, value: item, date: date, onChange: handleWakeupValueChange(i), onDelete: removeDaytimeNap(i), daytimeNaps: values.daytimeNaps, listIndex: i, validationItem: unValidDaytimeNaps === null || unValidDaytimeNaps === void 0 ? void 0 : unValidDaytimeNaps.filter(function (d) { return d.index === i; }) })); }),
                React.createElement("div", { className: classes.addDayTimeNapsBtnSection },
                    React.createElement(core_1.Button, { variant: "contained", color: "secondary", onClick: addDaytimeNap, startIcon: React.createElement(icons_1.AddIcon, null), disabled: disabled }, translate('sleepDiary.addSleepTime'))))))));
};
exports.default = LogNaps;
